<template>
  <div class="form-group" :class="{'-filled': inputValue}">
    <div class="input -required">
      <input type="number" :step="step" class="form-control -filled" :name="identifier" :id="identifier" v-model="inputValue" :class="{'-filled': inputValue}" :max="max" :min="min" @input="debouncedSearch">
      <div class="input-background">
        <label class="control-label" :for="identifier"></label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, computed } from 'vue'
import debounce from 'lodash.debounce';

const props = defineProps({
    identifier: {
        type: String,
        default: ''
    },
    value: {
        type: [Number, String],
    },
    min: {
        type: Number,
    },
    max: {
        type: Number,
    },
    step: {
      type: Number,
      default: 0.1
    },
})

const emit = defineEmits(['update:modelValue', 'handleTracking', 'triggerFilter'])

const debouncedSearch = debounce(() =>
{
  emit('triggerFilter', inputValue)
}, 1500)


const inputValue = computed({
  get () {
    return props.value
  },
  set (value) {
    if (value < props.min) {
      value = props.min
    }
    if (value > props.max) {
      value = props.max
    }
    value = parseFloat(value)
      emit('update:modelValue', value)
      emit('handleTracking', value)
  }
})

</script>
